var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 419,
    height: 100,
    viewBox: "0 0 419 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H419V100H0L31.0195 60.2447C35.4981 54.5049 35.537 46.4651 31.1141 40.6821L0 0Z",
    fill: "#E11010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageRed);
export default __webpack_public_path__ + "static/media/messageRed.efa784ec3eebc866ef9a885b4a6e267b.svg";
export { ForwardRef as ReactComponent };